export const PRICE = '23 USD'

export const BRAND = 'PMU Instructor Ready™'

/** Interior pages from Volume 2, in the required order. Real pages are 4:5. */
export const insidePages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/imvhY2fxa3k6C6qcX6Xi72/01_pagina_5.webp',
    caption: 'Volume 2 — Page 5',
    label: 'Brow Design, Mapping & Facial Analysis',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kpkdyZEi28cCajz24v3uJQ/02_pagina_32.webp',
    caption: 'Volume 2 — Page 32',
    label: 'Microblading Hair-Stroke Concepts',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/wcZH2Nrt8wHa5nCZqn66tr/03_pagina_36.webp',
    caption: 'Volume 2 — Page 36',
    label: 'Lip Blush: What Makes It Complex',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4Gp9e8JerrFEKXd28QpUoB/04_pagina_16.webp',
    caption: 'Volume 2 — Page 16',
    label: 'Eye PMU: Classroom Teaching Concepts',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/idqWwHiEcuhuqQrhpU31Wy/05_pagina_18.webp',
    caption: 'Volume 2 — Page 18',
    label: 'Color Theory & Pigment Fundamentals',
  },
]

export const heroHighlights = [
  '6 Organized Teaching Volumes',
  'Ready-to-Use Educational Resources',
  'Student Worksheets & Activities',
  'Assessment & Feedback Templates',
  'Instant Digital Access',
]

export const painPoints = [
  {
    title: 'Endless Lesson Planning',
    text: 'You spend valuable time deciding what to teach, how to structure it, and which materials to prepare.',
  },
  {
    title: 'Worksheets From Scratch',
    text: 'Every new class means creating another exercise, practice sheet, or student resource.',
  },
  {
    title: 'Scattered Teaching Materials',
    text: 'Your references, activities, and assessment tools are spread across different files.',
  },
  {
    title: 'Repeated Student Questions',
    text: 'Without structured learning resources, you end up explaining the same concepts again and again.',
  },
]

export const solutionBenefits = [
  { title: 'Organize Lessons Efficiently', text: 'Start from structured frameworks instead of blank pages.', tint: '#F6D5D0' },
  { title: 'Support Your Students', text: 'Guide learning with structured activities and worksheets.', tint: '#D9ECF8' },
  { title: 'Evaluate Learning', text: 'Use ready-to-use quizzes, rubrics, and feedback tools.', tint: '#DDE9DC' },
  { title: 'Teach Consistently', text: 'Create a more consistent experience across every class.', tint: '#E9DDF4' },
]

/** Accent colors match the covers in the mockup. */
export const volumes = [
  {
    number: 1,
    title: 'The Complete PMU Education & Teaching Foundations',
    description: 'Build a stronger foundation for planning, organizing, and delivering PMU education.',
    accent: '#F9DCD3',
  },
  {
    number: 2,
    title: 'The Professional PMU Techniques & Training Guide',
    description: 'Explore educational references covering brows, lips, eyeliner, pigment theory, and technique concepts.',
    accent: '#F6D5D0',
  },
  {
    number: 3,
    title: 'The Ready-to-Teach PMU Lesson System',
    description: 'Use structured lesson frameworks to simplify classroom preparation.',
    accent: '#D9ECF8',
  },
  {
    number: 4,
    title: 'The PMU Student Practice & Skills Workbook',
    description: 'Support learning with student activities, worksheets, and guided exercises.',
    accent: '#DDE9DC',
  },
  {
    number: 5,
    title: 'The PMU Assessment, Feedback & Certification Toolkit',
    description: 'Organize quizzes, student evaluations, feedback, and training-completion records.',
    accent: '#E9DDF4',
  },
  {
    number: 6,
    title: 'The PMU Instructor Classroom & Training Management System',
    description: 'Manage classroom organization, teaching records, and training workflows.',
    accent: '#F7E3B0',
  },
]

export const bonuses = [
  {
    number: 'Bonus 1',
    title: 'The PMU Client Consultation & Consent Template Pack',
    description: 'Templates to structure client consultations and consent conversations in class.',
    accent: '#F6D5D0',
  },
  {
    number: 'Bonus 2',
    title: 'The PMU Color Theory & Pigment Selection Quick Reference Guide',
    description: 'A compact reference to support color and pigment discussions with students.',
    accent: '#DDE9DC',
  },
  {
    number: 'Bonus 3',
    title: 'The PMU Instructor Demonstration & Live Training Checklist Pack',
    description: 'Checklists to prepare and run demonstrations and live training sessions.',
    accent: '#D9ECF8',
  },
  {
    number: 'Bonus 4',
    title: 'The PMU Student Knowledge Quiz & Answer Key Collection',
    description: 'Ready-made quizzes with answer keys to review student understanding.',
    accent: '#E9DDF4',
  },
  {
    number: 'Bonus 5',
    title: 'The PMU Aftercare Education & Client Communication Toolkit',
    description: 'Resources to teach aftercare education and clear client communication.',
    accent: '#F7E3B0',
  },
]

export const beforeItems = [
  'Searching for teaching references',
  'Writing lesson plans from scratch',
  'Creating worksheets one by one',
  'Organizing scattered files',
  'Building assessment forms yourself',
]

export const afterItems = [
  'Start with structured teaching resources',
  'Adapt existing lesson frameworks',
  'Use organized student worksheets',
  'Find materials within one collection',
  'Access assessment and feedback templates',
]

export const audience = [
  { title: 'PMU Instructors', text: 'Who want to organize their lessons and save preparation time.' },
  { title: 'Permanent Makeup Trainers', text: 'Who need structured educational resources for their students.' },
  { title: 'Beauty Academy Owners', text: 'Who want greater consistency across their PMU training materials.' },
  {
    title: 'PMU Artists Moving Into Education',
    text: 'Who want a clearer framework for developing their teaching resources.',
  },
]

export const offerIncludes = [
  '6 Teaching Volumes',
  '5 Additional Educational Resources',
  'Structured Lesson Frameworks',
  'Student Worksheets & Activities',
  'Assessment & Feedback Templates',
  'Digital PDF Format',
  'Instant Access After Purchase',
  'One-Time Payment',
]

export const steps = [
  { title: 'Get Instant Access', text: 'Complete your secure purchase and access your digital resources.' },
  { title: 'Explore Your Materials', text: 'Download the volumes, worksheets, lesson frameworks, and bonuses.' },
  {
    title: 'Prepare Your Next Class',
    text: 'Select the relevant materials and adapt them to your students, qualifications, and local requirements.',
  },
]

export const faqs = [
  {
    question: 'Is this a physical product?',
    answer: 'No. PMU Instructor Ready™ is a digital collection of PDF educational resources.',
  },
  {
    question: 'Will I receive access immediately?',
    answer: 'Yes. Digital access is provided after successful purchase.',
  },
  {
    question: 'Can I use these materials to organize my PMU classes?',
    answer:
      'Yes. The system includes lesson frameworks, educational references, student activities, and assessment resources that you can adapt to your teaching needs.',
  },
  {
    question: 'Is this suitable for PMU instructors and academy owners?',
    answer:
      'Yes. It is designed for PMU educators, trainers, and academy owners looking for structured teaching support.',
  },
  {
    question: 'Does this replace hands-on professional training or licensing?',
    answer:
      'No. The materials are educational resources and do not replace required qualifications, supervised practical training, or local licensing requirements.',
  },
  {
    question: 'Are the PDFs editable?',
    answer: 'No. The materials are supplied as PDF documents.',
  },
  {
    question: 'Is the payment secure?',
    answer:
      'Yes. Checkout is secure and encrypted, and your payment is processed automatically in your local currency.',
  },
]
